// src/components/uploadSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  petname: "",
  files: [],
};

const uploadSlice = createSlice({
  name: "upload",
  initialState,
  reducers: {
    setPetname: (state, action) => {
      state.petname = action.payload;
    },
    setFiles: (state, action) => {
      state.files = action.payload;
    },
    clearUpload: () => initialState,
  },
});

export const { setPetname, setFiles, clearUpload } = uploadSlice.actions;
export default uploadSlice.reducer;
